import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[620px] overflow-hidden" aria-label="首页横幅">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20and%20amber%20light%20rays%20streaming%20through%20film%20reel%20and%20theater%20curtains%2C%20elegant%20movie%20theater%20ambience%2C%20abstract%20artistic%20composition%2C%20luxurious%20deep%20red%20and%20dark%20tones%2C%20professional%20cinematic%20photography%2C%20dramatic%20lighting&width=1920&height=900&seq=hero-bg-cinema&orientation=landscape"
        alt="屁屁影院 - 精选影视资源在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-6 text-center">
        <h1
          className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          精选影视，即刻畅享
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          海量高清电影、电视剧、动漫、综艺 — 无需注册，免费观看，每日更新
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-xl">
          <div className="relative w-full">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
            <input
              type="text"
              placeholder="搜索你想看的电影、电视剧..."
              className="w-full pl-11 pr-4 py-3 rounded-full bg-white/15 backdrop-blur-md border border-white/20 text-white placeholder-white/50 text-sm focus:outline-none focus:border-white/40 transition-colors"
            />
          </div>
          <Link
            to="/category/movie"
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            立即探索
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-8">
          {[
            { icon: 'ri-film-line', label: '10,000+ 电影' },
            { icon: 'ri-tv-line', label: '5,000+ 剧集' },
            { icon: 'ri-emotion-line', label: '3,000+ 动漫' },
            { icon: 'ri-live-line', label: '800+ 综艺' },
          ].map((stat) => (
            <div key={stat.label} className="flex items-center gap-2 text-white/70 text-sm">
              <i className={`${stat.icon} text-base`}></i>
              <span className="whitespace-nowrap">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}